import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-dialog-change-email",
  templateUrl: "./dialog-change-email.component.html",
  styleUrls: ["../../dashboard.style.scss"],
})
export class DialogChangeEmailComponent implements OnInit {

  emailControl: FormControl;
  constructor(private dialogRef: MatDialogRef<DialogChangeEmailComponent>) {}

  ngOnInit(): void {
    this.emailControl = new FormControl("");
  }

  onSubmit() {
    this.dialogRef.close(this.emailControl.value);
  }
}
